import { notification } from 'antd';
import { ArgsProps, NotificationInstance } from 'antd/es/notification/interface';

let requestNotificationApi: NotificationInstance | undefined;

export const setRequestNotificationApi = (notificationApi: NotificationInstance) => {
  requestNotificationApi = notificationApi;
};

export const openRequestErrorNotification = (args: ArgsProps) => {
  if (requestNotificationApi) {
    requestNotificationApi.error(args);
    return;
  }

  notification.error(args);
};
